<script setup>
import { ref, onMounted, onUnmounted, defineProps, nextTick, computed  } from "vue";
import { ecShopAdvisoryVisibility } from "@/api/common";
import { setCurrentPageTitle } from "@/core/helpers/breadcrumb";
import {getMatchinPayBalance, proceedMatchinPayQRPayment}  from "@/api/matchinpay";
import { setCurrentUser,getCurrentUser } from '../../utils/index';
import { useRouter } from "vue-router"; 
import Swal from "sweetalert2/dist/sweetalert2.js";
import domtoimage from "dom-to-image";


const router = useRouter();

const props = defineProps(["qrBranchName", "qrMerchantCode", "qrAccountNumber"]);


const current_usid = ref("");
const isOverriden = ref(false);
const ccode = ref(-1);
const isValidInputAmount = ref(false);

const returnMerchantName = ref("");
const returnMerchantCode = ref("");
const returnAmount = ref(0.00);
const paymentDate = ref("");
const paymentRecid = ref(0);
const taggedTopUpAmount = ref(0);
const paymentCheckIcon = ref("");


onMounted(() => {

  if(props.qrBranchName === undefined && props.qrMerchantCode === undefined && props.qrAccountNumber === undefined){
    router.push({ name: "mgpayscan"});
  } else {
    const tabIndex = ref(0);
    // set the tab from previous
    tabIndex.value = parseInt(localStorage.getItem("dmpayqrpaymentTab") || "0");
    setCurrentPageTitle("MG Payment");


    let currentUser = getCurrentUser();
    let override_cifid  = localStorage.getItem('override_cifid');

    if(currentUser !== undefined){
        current_usid.value = currentUser.usid ;
    }
    if (override_cifid != null) {
        isOverriden.value = true;
    }

    ccode.value = Number(localStorage.getItem("ccode"));

    // if(ccode.value === 0  && isOverriden.value == false && current_usid.value === "HKG14776"){
    if(ccode.value === 0  && isOverriden.value == false ){
      hideECShopAdvisory();
      getMatchinPayBalanceLocal();
      onResize();
    } else {
      router.push({ name: "estore"});
    }
  }




  
  
});

onUnmounted(() => {
  
});


const matchinBalance = ref(0.00);
const currency = ref("");

const getMatchinPayBalanceLocal = async () => {
  const response = await getMatchinPayBalance();
    if(response.data != undefined && response.data != null){
      matchinBalance.value = response.data.matchinpaybalance;
      currency.value = response.data.currency;
    }
};



const isShowReceipt = ref(false);

const hideECShopAdvisory = () => {
  ecShopAdvisoryVisibility.hide();
};

const showECShopAdvisory = () => {
  ecShopAdvisoryVisibility.show();
};


const goToDMPayPage = () => {
  router.push({ name: "mgpay"});
}

const proceedPayment = async () => {
  isProcessing.value = true;

  if(parseFloat(payment_amount.value) < 0){
    Swal.fire({
      title: "",
      text: "Please input an amount greater than zero (0.00).",
      icon: "error",
      confirmButtonClass: "btn btn-secondary"
    }); 
  } else {
    let param = {
      amt : parseFloat(payment_amount.value).toFixed(2),
      merchant : props.qrMerchantCode,
      accountno : props.qrAccountNumber
    }

    const response = await proceedMatchinPayQRPayment(param);

    if (response.data.result == "SUCCESS") {
      returnMerchantName.value = response.data.returnMerchantName;
      returnMerchantCode.value = response.data.returnMerchantCode;
      returnAmount.value = response.data.returnAmount;
      paymentDate.value = response.data.returnPaymentDate; 
      paymentRecid.value = response.data.returnPaymentRecid;
      taggedTopUpAmount.value = response.data.taggedTopUpAmount;

      console.log(taggedTopUpAmount.value);

      if(taggedTopUpAmount.value == 2000.00){
        paymentCheckIcon.value = "media/icons/duotone/Shopping/Payment-Check_Blue.svg";
      } else if(taggedTopUpAmount.value == 5000.00){
        paymentCheckIcon.value = "media/icons/duotone/Shopping/Payment-Check_Pink.svg";
      }

      


      isShowReceipt.value = true;
      
      
    } else if(response.data.result == "FAILED"){
      Swal.fire({
        title: "",
        text: response.data.message,
        icon: "error",
        confirmButtonClass: "btn btn-secondary"
      }); 
    }
  }

  isProcessing.value = false;
}

const removeLeftZeroesInPaymentAmount = () => {
  payment_amount.value = parseFloat(payment_amount.value).toFixed(2);


  if(payment_amount.value > 0){
    isValidInputAmount.value = true;
  } else {
    isValidInputAmount.value = false;
  }
}



const isProcessing = ref(false);
const payment_amount = ref(0.00);


const captureDivResibo = ref(null);
const canvas = ref(null);

// const downloadAsImage = async () => {
//   if (!captureDivResibo.value || !canvas.value) return;

//   await nextTick(); // Ensure DOM updates before capturing

//   const div = captureDivResibo.value;
//   const ctx = canvas.value.getContext("2d");

//   // Set canvas size to match div
//   const width = div.offsetWidth;
//   const height = div.offsetHeight;
//   canvas.value.width = width;
//   canvas.value.height = height;

//   // Draw the div onto the canvas (basic method)
//   ctx.fillStyle = "white"; // Set background color
//   ctx.fillRect(0, 0, width, height);
//   ctx.font = "20px Arial";
//   ctx.fillStyle = "black";
//   ctx.fillText(div.innerText, 10, 30); // Simple text rendering (limited)

//   // Convert canvas to image and trigger download
//   const image = canvas.value.toDataURL("image/png");
//   const link = document.createElement("a");
//   link.href = image;
//   link.download = "screenshot.png";
//   link.click();
// };


const downloadAsImage = async () => {
  console.log("downloadAsImage");

  await nextTick(); // Ensures Vue has finished rendering
  if (!captureDivResibo.value) {
    console.error("Error: captureDivResibo is null!");
    return;
  }


   domtoimage.toPng(captureDivResibo.value, {
      filter: (node) => node.tagName !== "LINK", // Ignores external stylesheets
      useCORS: true,
    })
    .then((dataUrl) => {
      const link = document.createElement("a");
      link.href = dataUrl;
      link.download = "screenshot.png";
      link.click();
    })
    .catch((error) => alert("Error capturing image: " + error));

};


const windowWidth = ref(window.innerWidth);
const matchinpayLogo = ref("");
const logoStyle = ref({});

const onResize = async  () =>  {
  //this.windowHeight = window.innerHeight;
  windowWidth.value = window.innerWidth;
  if(windowWidth.value <= 450){
    matchinpayLogo.value = await convertImageToBase64("https://images.empoweredconsumerism-static-files.com/ecp/MG_PAY_MOBILE.png");

    logoStyle.value = {width:"100px", height: "auto"}
  } else {
    matchinpayLogo.value = await convertImageToBase64("https://images.empoweredconsumerism-static-files.com/ecp/MG_PAY_PC.png");
      logoStyle.value = {width:"300px", height: "auto"}
  }
}


const convertImageToBase64 = (url) => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.crossOrigin = 'Anonymous'; // Important for remote images
    img.onload = () => {
      const canvas = document.createElement('canvas'); // ← Safe, temp canvas
      canvas.width = img.width;
      canvas.height = img.height;
      const ctx = canvas.getContext('2d');
      ctx.drawImage(img, 0, 0);
      resolve(canvas.toDataURL('image/png'));
    };
    img.onerror = reject;
    img.src = url;
  });
};


const buttonColor = computed(() => ({
  backgroundColor: taggedTopUpAmount.value == 2000.00 ? '#0000ab' : '#b80c50',
}));

</script>

<style >
.input-container {
  position: relative;
  display: inline-block;
}

.placeholder {
  position: absolute;
  left: 20px;
  top: 50%;
  transform: translateY(-50%);
  color: gray;
  pointer-events: none;
}

.input_amount {
  padding-left: 40px; /* Space for placeholder */
}


.capture-area {
  font-family: "Poppins", sans-serif;
  width: 100%;
  padding: 20px;
  background-color: rgb(255, 255, 255);
  text-align: center;
  border: 1px solid #ccc;
  border-radius: 10px;
}




</style>

<template>
  
  <div  class="card mb-5" v-if="isShowReceipt === false">
    <!--begin::Body-->
    <div class="card-body py-3 ">
        <div class="col-xxl-12 mb-5 text-center">
          <img :src="matchinpayLogo" :style="logoStyle" />
        </div>
      <div class="mb-10 mt-6">
          <div class="d-flex align-items-center">
            <span class="svg-icon svg-icon-success me-4">
              <inline-svg style="width:2.75rem !important;height:2.75rem !important;"
                  src="media/icons/duotone/Shopping/Store.svg"
                />
            </span>
            <div class="fw-bolder" data-kt-countup="true" data-kt-countup-value="4500" data-kt-countup-prefix="$">
              {{ props.qrBranchName }}
              <!-- <br/>
              {{ qrMarchantCode }} -->
            </div>
          </div>
      </div>

      <div class="row mb-10">
        <label class="col-lg-2 col-form-label fs-6 mb-3">
          <span class="">Amount</span>
        </label>
        <div class="col-lg-8 fv-row">
          <div class="row ">
            <!-- <div class="col-lg-1"><span>{{currency}}</span></div>
            <div class="col-lg-10"><input type="text" class="form-control form-control-lg form-control-solid" placeholder="0.00"></div> -->

            <div class="input-container mt-2">
              <span class="placeholder">{{currency}}</span>
              <input v-model="payment_amount"  v-on:blur="removeLeftZeroesInPaymentAmount()" class="form-control form-control-lg form-control-solid input_amount" type="number" placeholder="0.00" />
            </div>

          </div>
          
          
        </div>
      </div>
      

      <div class="row mb-10">
        <label class="col-lg-2 col-form-label mt-3 fs-6">
          <span class="">Balance</span>
        </label>
        <div class="col-lg-10 fv-row " >
          <label class="col-lg-2 col-form-label mt-1 fs-2">
            <span class="">{{currency}} {{numberWithCommas(matchinBalance.toFixed(2))}}</span>
          </label>
        </div>
      </div>
      <div class="row mb-10">
        <button type="button" class="btn btn-primary" v-if="isProcessing === false" v-on:click="proceedPayment()" :disabled = !isValidInputAmount>
          <span class="indicator-label"> Pay </span>
        </button>
        <button type="button" class="btn btn-primary" v-if="isProcessing === true">
          <span class="indicator-label"><span class="spinner-border spinner-border-sm align-middle ms-2"></span></span>
        </button>
      </div>

    </div>
  </div>


  <div  class="capture-area" v-if="isShowReceipt === true" ref="captureDivResibo">
    
    <!--begin::Close-->
    <div style="text-align:right;">
      <div
        class="btn btn-sm btn-icon btn-active-color-primary" v-on:click="goToDMPayPage();"
      >
        <span class="svg-icon svg-icon-1">
          <inline-svg src="media/icons/duotone/Navigation/Close.svg" />
        </span>
      </div>
    </div>
          <!--end::Close-->
    <div class="col-xxl-12 mb-5 text-center">
      <img :src="matchinpayLogo" :style="logoStyle" />
    </div>
    <!--begin::Body-->
    <div class="card-body py-3 ">
      <div class="row mb-10 mt-6 align-items-center ">
          <div class="align-items-center text-center">
            <span class="svg-icon svg-icon-success me-4">
              <inline-svg style="width:5.75rem !important;height:5.75rem !important;color:#53ed22;"
                  :src="paymentCheckIcon"
                />
            </span>
            <div class="fw-bolder fs-2" data-kt-countup="true" data-kt-countup-value="4500" data-kt-countup-prefix="$">
              Successful Payment
              <!-- <br/>
              {{ qrMarchantCode }} -->
            </div>
          </div>
      </div>
      
      <hr>
      <div class="row text-center">
        <div class="col-md-6  fw-bolder">Reference #: </div>
        <div class="col-md-6 " >{{paymentRecid}}</div>
      </div>
      <hr>
      <div class="row text-center">
        <div class="col-md-6  fw-bolder">Paid To: </div>
        <div class="col-md-6 " >{{returnMerchantName}} ({{ returnMerchantCode}})</div>
      </div>
      <hr>
      <div class="row text-center">
        <div class="col-md-6  fw-bolder">Amount:</div>
        <div class="col-md-6 " style="">{{currency}} {{ numberWithCommas(returnAmount) }}</div>
      </div>
      <hr>
      <div class="row text-center">
        <div class="col-md-6 fw-bolder">Date:</div>
        <div class="col-md-6 " style="">{{ paymentDate }}</div>
      </div>
      <hr>
      <div class="row mb-10 fw-bolder">
          <button type="button" class="btn btn-primary"  v-on:click="downloadAsImage()" :style="buttonColor">
            <span class="indicator-label"> Download Image </span>
          </button>
      </div>
      <!-- Hidden Canvas -->
      <canvas ref="canvas" style="display: none;"></canvas>

    </div>
  </div>





</template>